<xilo-lib-dialog [xiloDialogConfig]='xiloDialogConfig'>
  <form class="xilo-dialog__form">
    <div class="xilo-dialog__body">
      <div class="flex flex-col gap-2">
        <div class="flex justify-between">
          <span class="font-inter-bold text-left text-base">{{data.headerText}}</span>
          <span class="font-inter-semi-bold text-right text-base">{{ progressBar.toFixed(0)}}%</span>
        </div>
        <span class="font-inter-regular text-black text-base">{{data.description}}</span>
        <div>
          <mat-progress-bar mode="determinate" value="{{progressBar}}"></mat-progress-bar>
        </div>
      </div>
    </div>
    <div class="xilo-dialog__footer gap-4 grid grid-cols-1">
      <button (click)="closeDialog()" type="button" xilo-button color="primary-border">{{ data.buttonText}}</button>
    </div>
  </form>
</xilo-lib-dialog>